import { findLink } from '../utilities/linkUtilities';
import { BLOCK_TYPE, STYLE } from '../utilities/CONSTANTS';
import { containsStyle, containsEntities } from '../utilities/blockUtilities';

const findLinkText = (contentBlock, callback) => {
    const links = findLink.match(contentBlock.get('text'));
    let start;
    let end;

    if (typeof links !== 'undefined'
        && links !== null
        && contentBlock.get('type') !== BLOCK_TYPE.CODE) {
        for (let i = 0; i < links.length; i += 1) {
            start = links[i].index;
            end = links[i].lastIndex;

            if (!containsEntities(contentBlock, links[i].index, links[i].lastIndex)
                && !containsStyle(contentBlock, STYLE.CODE, links[i].index, links[i].lastIndex)
            ) {
                if (contentBlock.get('text').charAt(end) === '?') {
                    end = contentBlock.get('text').length;
                }
                callback(start, end);
            }
        }
    }
};

export default findLinkText;
